import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: ':order/budget-groupings/:orderBudget/flights/create',
    name: 'CreateOrderBudgetGroupingFlight',
    component: () => import('@/views/order-flight/edit.vue'),
    meta: {
      title: 'Passport | Create Order Budget Grouping Flight',
      layout: 'LayoutAuthenticated',
      redirectPath: '/orders',
      requiresAuth: true,
    },
  },
  {
    path: ':order/budget-groupings/:orderBudget/flights/:orderFlight/:tab?',
    name: 'EditOrderBudgetGroupingFlight',
    component: () => import('@/views/order-flight/edit.vue'),
    meta: {
      title: 'Passport | Edit Order Budget Grouping Flight',
      layout: 'LayoutAuthenticated',
      redirectPath: '/orders',
      requiresAuth: true,
    },
  },
] as RouteRecordRaw[]
